import { useContext } from "react";
import { Route, BrowserRouter as RouterProvider, Routes, Navigate } from "react-router-dom";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./styles/main.scss";
import { AuthContext } from "./context/AuthContext";
import Loader from "./components/Loader";
import { IconContext } from "react-icons/lib";
import RouterEcp from "./router/RouterEcp.jsx";
import Login from "./components/Forms/Login.jsx";

export default function App() {
  const { user, entrepriseRoles, isLoading } = useContext(AuthContext);
  
  if (isLoading) {
    return <Loader />;
  }

  return (
    <IconContext.Provider value={{ className: "react-icons" }}>
      {!user ? (
        <RouterProvider
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route path="/dast" element={<Login />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </RouterProvider>
      ) : (
        <>
          {!entrepriseRoles.isLoading ? (
            <RouterEcp entrepriseRoles={entrepriseRoles} />
          ) : (
            <Loader />
          )}
        </>
      )}
    </IconContext.Provider>
  );
}
